import { filterUnique } from '../../shared/data.format.factory';
import { convertToCurrencyInTable } from '../../shared/_helpers';
import { GroupControllerV1 } from '../../shared/group-v1';
import { HTMLSource } from '../../shared/html/html-source';
export class PaymentsGroupV1 extends GroupControllerV1 {
    constructor(page, config, index) {
        super(page, config, index);
        this.page = page;
        this.config = config;
        this.index = index;
    }
    html() {
        const graphWrapper = super.html();
        let source = HTMLSource(graphWrapper === null || graphWrapper === void 0 ? void 0 : graphWrapper.parentElement, this.page.main.params.language, "NL-EITI");
        return graphWrapper;
    }
    prepareData(data) {
        const dataGroup = "reconciliation";
        if (data[dataGroup] == undefined)
            return;
        this.uniqueSectors = filterUnique(data[dataGroup], "sector");
        const multiples = [];
        for (let us of this.uniqueSectors.slice()) {
            multiples.push(data[dataGroup].filter(r => r.sector == us));
        }
        const values = data[dataGroup].map(r => r.payments_companies);
        const range = [window.d3.min(values), window.d3.max(values)];
        // FOR TABLE
        const rows = [];
        const columnArray = filterUnique(data[dataGroup], "year");
        let rowArray = filterUnique(data[dataGroup], "origin").map(s => s.toString());
        rowArray.sort((a, b) => a.localeCompare(b));
        const rowName = "entity_name";
        const rowSlug = "origin";
        const columnName = "year";
        const columnSlug = "year";
        const valueKey = "payments_companies";
        for (const r of rowArray) {
            const row = [];
            const report = data[dataGroup].find((s) => s[rowSlug] === r);
            if (report != undefined)
                row.push(report[rowName]);
            for (const c of columnArray) {
                const item = data[dataGroup].find((s) => s[columnSlug] === c && s[rowSlug] == r);
                row.push(item != undefined ? convertToCurrencyInTable(item[valueKey] * 1000 * 1000) : "-");
            }
            rows.push(row);
        }
        const headers = this.page.main.params.language == 'en' ? ["Company"] : ["Bedrijf"];
        const table = {
            headers: headers.concat(columnArray.map(y => y.toString())),
            rows
        };
        return {
            multiples,
            range,
            table
        };
    }
    populateTable(tableData) {
        super.populateTable(tableData);
    }
    populateDescription() {
        super.populateDescription();
    }
    update(data, segment, update) {
        super.update(data, segment, update);
    }
}
